<template>
    <div class="border rounded shadow-sm bg-white" style="padding: 20px;">
        <div class="d-flex justify-content-between">
            <h4 class="mb-0">Quick Sharing Link</h4>
            <instructions-modal
                modal-title="Quick Sharing Link - Instructions"
                button-size="sm"
                button-variant="minimal-info"
            >
                <ul class="list-flush list-margin-2">
                    <li>When enabled, you can share this link with anyone and have it link directly to the RFX page.</li>
                    <li>The RFx will be visible to anyone with the link, but they are not indexed by search engines.</li>
                    <li>This is the only URL to the RFX that you should share -- internal URLs that you see only work for logged-in users with specific access.</li>
                    <li>
                        Add additional response forms as needed.  You can add as many as you need, of any of the three types.
                    </li>
                </ul>
            </instructions-modal>
        </div>
        
        <hr class="my-2">
        <!-- <base-single-collapse
            button-text="Instructions"
            class="my-3"
        >
            <ul class="list-flush">
                <li>When enabled, you can share this link with anyone and have it link directly to the RFX page.</li>
                <li>The RFx will be visible to anyone with the link, but they are not indexed by search engines.</li>
                <li>This is the only URL to the RFX that you should share -- internal URLs that you see only work for logged-in users with specific access.</li>
                <li>
                    Add additional response forms as needed.  You can add as many as you need, of any of the three types.
                </li>
            </ul>
        </base-single-collapse> -->

        <div class="d-flex justify-content-between align-items-center my-3">
            <div>
                <b-form-checkbox
                    switch 
                    size="md" 
                    v-model="quicklinks_enabled" 
                    class=""
                    @change="handleEnableChanged"
                >
                    <span v-if="quicklinks_enabled">Link Sharing ON</span>
                    <span v-else>Link Sharing Off</span>
                    <b-spinner v-if="loading" small variant="primary" label="Loading Quick Link" class="ml-2"></b-spinner>
                </b-form-checkbox>
            </div>
            <div v-if="quicklinks_enabled && rfx_open_for_invites">
                <b-button
                    variant="subtle-primary" 
                    size="sm"
                    class="my-2 text-nowrap"
                    @click="confirmRegenerate"
                >
                    <b-icon icon="arrow-repeat" class="mr-2"></b-icon>
                    Generate New Link
                </b-button>
            </div>
        </div>
        
        <transition name="scale-in-out">
            <div v-if="quicklinks_enabled && is_quicklink_active">
                <div class="">
                    <base-clipboard-copy-input
                        :copy-text="fullQuicklinkUrl" 
                        size="sm"
                        button-text-start="Copy"
                        :disabled="!is_quicklink_active"
                    ></base-clipboard-copy-input>
                </div>
            </div>
            <div v-else-if="quicklinks_enabled">
                <div class="text-center text-muted font-weight-bold">
                    Link Hidden
                </div>
                <div class="text-center text-muted font-italic small">
                    Vendors cannot use quick sharing link unless event is OPEN
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service'
export default {
    name: 'RfxManageQuicklinks',
    props: {
        rfxPk: {
            type: [Number, String],
            required: true,
        }
    },
    data: function() {
        return {
            error: false,
            errorMsg: 'Error while managing Quick Link',
            loading: false,
            quicklink_active: {},  // object, will get completely replaced during any API call
            is_quicklink_active: false,  // will get from API, uses model @property -- is the quicklink actually working RIGHT NOW based on current RFX state, tenant settings, rfx setting, etc.?
            quicklinks_enabled: false,
            rfx_open_for_invites: false,  
            rfx_state_dict: {},  // full rfx.state_dict object
        }
    },
    computed: {
        hasQuicklink: function() {
            return this.quicklink_active.full_url ? true : false;
        },
        fullQuicklinkUrl: function() {
            if (this.hasQuicklink && !this.loading) {
                return this.quicklink_active.full_url; 
            } else {
                return '';
            }
        }
    },
    mounted: function() {
        this.initialLoad();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        setDataFromResponse: function(response) {
            this.quicklink_active = Object.assign({}, response.data.quicklink_active);
            this.rfx_open_for_invites = response.data.rfx_open_for_invites;
            this.quicklinks_enabled = response.data.quicklinks_enabled;
            // NEW THINGS Nov 30 2021
            this.is_quicklink_active = response.data.is_quicklink_active;  // is it actually active RIGHT NOW considering Rfx state, Rfx settings, tenant settings, etc.
            this.rfx_state_dict = response.data.rfx_state_dict;  // full state_dict of the RFX
        },
        initialLoad: function() {
            this.loading = true;
            suppliosApi.rfx.getQuicklinkStatus(this.rfxPk)
            .then(response => {
                console.log('response from initialLoad of quicklink');
                console.log(response);
                this.setDataFromResponse(response);
            })
            .catch(error => {
                this.handleError(error, 'Error while loading Quick Link status');
            })
            .finally(() => this.loading = false)
        },
        confirmRegenerate: function() {
            // show a confirmation modal, then if confirmed, call the real regenerate
            this.$bvModal.msgBoxConfirm('When you generate a new sharing link, any previous sharing links will be invalid.  Please confirm if you would like to proceed.', {
                title: 'Are you sure?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: 'Yes, continue',
                cancelTitle: 'No, cancel',
                centered: true,
            })
            .then(value => {
                // value resolves to true if OK is clicked, false if cancel clicked, or null if modal closed
                if (value === true) {  // handle case where OK is clicked
                    this.regenerateQuicklink();
                } // no need for else here
            })
            .catch(error => {
                this.handleError(error, 'Error during confirmRegenerate');
            })
        },
        regenerateQuicklink: function() {
            this.loading = true;
            suppliosApi.rfx.regenerateQuicklink(this.rfxPk)
            .then(response => {
                console.log('response from regenerateQuicklink');
                console.log(response);
                this.setDataFromResponse(response);
            })
            .catch(error => {
                this.handleError(error, 'Error while generating new Quick Link');
            })
            .finally(() => this.loading = false)
        },
        handleEnableChanged: function(enableStatus) {
            // payload being passed in will be true or false (state of quicklinks_enabled)
            console.log('from handleEnableChanged, event is below:');
            console.log(enableStatus);
            this.loading = true;
            var updateObj = {   // this is the data we'll send to API using partial_update / PATCH
                quicklinks_enabled: enableStatus,
            };
            suppliosApi.rfx.updateQuicklinkStatus(this.rfxPk, updateObj)
            .then(response => {
                console.log('response from updateQuicklinkStatus');
                console.log(response);
                this.setDataFromResponse(response);
            })
            .catch(error => {
                this.handleError(error, 'Error during updateQuicklinkStatus');
            })
            .finally(() => this.loading = false)
        }
    }

}
</script>

<style>

</style>